import React from "react";
import SbEditable from "storyblok-react";
import RichText from "src/utils/RichText";
import FluidImage from "src/utils/FluidImage";
import Heading from "./Heading";
import Button from "./Button";

const LogoClouds = ({ blok }) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className="bg-white mt-16 mb-20 px-6 lg:mt-24 lg:mb-28 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <Heading size="h2" className="text-darkgrey">
            {blok.title}
          </Heading>
          <div className="prose text-sm font-body mx-auto">
            <RichText>{blok.description}</RichText>
          </div>
          <div className="mt-6 grid grid-cols-2 gap-1 md:grid-cols-4 lg:grid-cols-6 lg:mt-8">
            {blok.logos.map((item) => (
              <div className="py-8 px-8" key={item.id}>
                <FluidImage
                  image={item}
                  className="max-h-12 block object-contain m-auto"
                  contain
                />
              </div>
            ))}
          </div>
          {blok.button_text && (
            <Button
              target={`/${blok.button_target.cached_url}`}
              className="bg-red hover:bg-darkred mx-auto text-center"
            >
              {blok.button_text}
            </Button>
          )}
        </div>
      </div>
    </SbEditable>
  );
};

export default LogoClouds;
